import * as extendActionType from 'reducers/extendActionType';

export const GET_MEMBERSHIP_PLANS = 'membership/GET_MEMBERSHIP_PLANS';
export const ACTIVATE_PLAN = 'membership/ACTIVATE_PLAN';
export const DEACTIVATE_PLAN = 'membership/DEACTIVATE_PLAN';
export const GET_PLANS_FOR_HOME_PAGE = 'membership/GET_PLANS_FOR_HOME_PAGE';
export const CREATE_PLAN = 'membership/CREATE_PLAN';
export const CREATE_PLAN_DIALOG = 'membership/CREATE_PLAN_DIALOG';
export const EDIT_PLAN = 'membership/EDIT_PLAN';
export const EDIT_PLAN_DIALOG = 'membership/EDIT_PLAN_DIALOG';
export const GET_PLANS_FOR_DROPDOWN = 'membership/GET_PLANS_FOR_DROPDOWN';

export function getMembershipPlans(_, {offset, limit}) {
    return {
        type: GET_MEMBERSHIP_PLANS,
        httpRequest: {
            method: 'get',
            path: '/plans',
            params: {
                offset,
                limit,
            },
        },
        offset,
        limit,
    };
}

export function getPlansForDropdown(search) {
    return {
        type: GET_PLANS_FOR_DROPDOWN,
        httpRequest: {
            method: 'get',
            path: '/plans/dropdown',
            params: {
                search,
            },
        },
    };
}

export function createPlan(data) {
    return {
        type: CREATE_PLAN,
        httpRequest: {
            method: 'post',
            path: '/plans',
            data,
        },
    };
}

export function editPlan(planId, data) {
    return {
        type: EDIT_PLAN,
        httpRequest: {
            method: 'put',
            path: `/plans/${planId}`,
            data,
        },
        id: planId,
        fields: data,
    };
}

export function getMembershipPlansForHomePage() {
    return {
        type: GET_PLANS_FOR_HOME_PAGE,
        httpRequest: {
            method: 'get',
            path: '/plans/home',
        },
    };
}

export function activatePlan(planId) {
    return {
        type: ACTIVATE_PLAN,
        httpRequest: {
            method: 'put',
            path: `/plans/activate/${planId}`,
        },
        id: planId,
        fields: {isActive: true},
    };
}

export function deactivatePlan(planId) {
    return {
        type: DEACTIVATE_PLAN,
        httpRequest: {
            method: 'put',
            path: `/plans/deactivate/${planId}`,
        },
        id: planId,
        fields: {isActive: false},
    };
}

export function showCreatePlanDialog() {
    return {
        type: extendActionType.show(CREATE_PLAN_DIALOG),
    };
}

export function hideCreatePlanDialog() {
    return {
        type: extendActionType.clean(CREATE_PLAN_DIALOG),
    };
}

export function showEditPlanDialog(item) {
    return {
        type: extendActionType.show(EDIT_PLAN_DIALOG),
        item,
    };
}

export function hideEditPlanDialog() {
    return {
        type: extendActionType.clean(EDIT_PLAN_DIALOG),
    };
}



// WEBPACK FOOTER //
// ./src/reducers/membership/membershipActions.js